import { useLocalization } from "../../../features/localization/index.js";
import { createCommentVNode, createElementBlock, createElementVNode, defineComponent, normalizeClass, openBlock, toDisplayString, unref, withModifiers } from "vue";
//#region src/v2/blocks/request-block/components/RequestBodyViewToggle.vue?vue&type=script&setup=true&lang.ts
var _hoisted_1 = { class: "text-c-3 text-xxs -my-1 mr-2 flex justify-center gap-0.5 rounded p-0.5" };
var _hoisted_2 = [
	"aria-pressed",
	"disabled",
	"title"
];
var _hoisted_3 = ["aria-pressed"];
var _hoisted_4 = ["aria-pressed"];
var RequestBodyViewToggle_vue_vue_type_script_setup_true_lang_default = /*@__PURE__*/ defineComponent({
	__name: "RequestBodyViewToggle",
	props: {
		modelValue: {},
		showForm: {
			type: Boolean,
			default: true
		},
		showSchema: {
			type: Boolean,
			default: false
		},
		rawLabel: {},
		disabled: { type: Boolean }
	},
	emits: ["update:modelValue"],
	setup(__props) {
		const { translate } = useLocalization();
		return (_ctx, _cache) => {
			return openBlock(), createElementBlock("div", _hoisted_1, [
				__props.showForm ? (openBlock(), createElementBlock("button", {
					key: 0,
					"aria-pressed": __props.modelValue === "form",
					class: normalizeClass(["rounded px-1", __props.disabled ? "cursor-not-allowed opacity-50" : {
						"bg-b-3 text-c-1 cursor-default": __props.modelValue === "form",
						"hover:bg-b-3": __props.modelValue !== "form"
					}]),
					disabled: __props.disabled,
					title: __props.disabled ? unref(translate)("apiClient.requestBodyViewToggle.fixBody") : void 0,
					type: "button",
					onClick: _cache[0] || (_cache[0] = withModifiers(($event) => _ctx.$emit("update:modelValue", "form"), ["stop"]))
				}, toDisplayString(unref(translate)("apiClient.requestBodyViewToggle.form")), 11, _hoisted_2)) : createCommentVNode("", true),
				createElementVNode("button", {
					"aria-pressed": __props.modelValue === "raw",
					class: normalizeClass(["hover:bg-b-3 rounded px-1", { "bg-b-3 text-c-1 cursor-default": __props.modelValue === "raw" }]),
					type: "button",
					onClick: _cache[1] || (_cache[1] = withModifiers(($event) => _ctx.$emit("update:modelValue", "raw"), ["stop"]))
				}, toDisplayString(__props.rawLabel ?? unref(translate)("apiClient.requestBodyViewToggle.raw")), 11, _hoisted_3),
				__props.showSchema ? (openBlock(), createElementBlock("button", {
					key: 1,
					"aria-pressed": __props.modelValue === "schema",
					class: normalizeClass(["hover:bg-b-3 rounded px-1", { "bg-b-3 text-c-1 cursor-default": __props.modelValue === "schema" }]),
					type: "button",
					onClick: _cache[2] || (_cache[2] = withModifiers(($event) => _ctx.$emit("update:modelValue", "schema"), ["stop"]))
				}, toDisplayString(unref(translate)("apiClient.requestBodyViewToggle.schema")), 11, _hoisted_4)) : createCommentVNode("", true)
			]);
		};
	}
});
//#endregion
export { RequestBodyViewToggle_vue_vue_type_script_setup_true_lang_default as default };

//# sourceMappingURL=RequestBodyViewToggle.vue.script.js.map